import BottomSheet from "components/BottomSheet/BottomSheet";
import CustomButtonV2 from "components/CustomButtonV2/CustomButtonV2";
import IAHelpButton from "components/IaHelpButton/IaHelpButton";
import { useProfile } from "contexts/ProfileContext";
import { useTabela } from "contexts/Tabela";
import { useToast } from "contexts/ToastContext";
import IconButton from "core/components/IconButton";

interface FooterEmbarqueTodosProps {
	onClickOpenSomatorio: () => void;
	handleOpenInsightsViagem: () => void;
	setOpenUsuario: (open: boolean) => void;
	openMoreOptions: boolean;
	setOpenMoreOptions: (open: boolean) => void;
	buscarEmbarquePorId: (mostrarHistorico: boolean) => void;
}

function FooterEmbarqueTodos({
	onClickOpenSomatorio,
	handleOpenInsightsViagem,
	setOpenUsuario,
	openMoreOptions,
	setOpenMoreOptions,
	buscarEmbarquePorId,
}: FooterEmbarqueTodosProps) {
	const { contextoEmbarque } = useProfile();
	const { tabelaRedux } = useTabela();
	const { showToast } = useToast();
	return (
		<>
			<div className="footer-space-between">
				<div>
					{contextoEmbarque !== "templateEmbarque" && (
						<CustomButtonV2
							classCss="custom-button-user"
							classText="button-texto-user"
							titulo="Exibir Somatório"
							cor="#FFFFFF"
							onClick={onClickOpenSomatorio}
						/>
					)}
					<CustomButtonV2
						classCss="custom-button-user"
						classText="button-texto-user"
						titulo="Obter Usuário"
						cor="#FFFFFF"
						onClick={() => {
							if (tabelaRedux.usuarioAlteracao) {
								setOpenUsuario(true);
							} else {
								showToast("Selecione Uma Coluna", "error");
							}
						}}
					/>
					<CustomButtonV2
						classCss="custom-button-historico"
						classText="button-texto-user"
						titulo="Histórico"
						cor="#FFFFFF"
						onClick={() => {
							if (tabelaRedux.colunaSelecionada) {
								buscarEmbarquePorId(true);
							} else {
								showToast("Selecione Uma Coluna", "error");
							}
						}}
					/>
				</div>
				<div>
					<IAHelpButton onClick={handleOpenInsightsViagem}>
						<span>Insights Viagens</span>
					</IAHelpButton>
				</div>
			</div>
			<div className="footer-mobile">
				<IAHelpButton onClick={handleOpenInsightsViagem}>
					<span>Insights Viagens</span>
				</IAHelpButton>
				<IconButton
					icon="Plus"
					size="lg"
					borderColor="#c3c3c3"
					backgroundColor="rgba(0, 0, 0, 0)"
					theme="dark"
					onClick={() => setOpenMoreOptions(true)}
				/>
			</div>
			<BottomSheet
				open={openMoreOptions}
				onClose={() => setOpenMoreOptions(false)}
				title="Mais opções"
			>
				{contextoEmbarque !== "templateEmbarque" && (
					<p onClick={onClickOpenSomatorio}>Exibir Somatório</p>
				)}

				<p
					onClick={() => {
						setOpenMoreOptions(false);
						if (tabelaRedux.usuarioAlteracao) {
							setOpenUsuario(true);
						} else {
							showToast("Selecione Uma Coluna", "error");
						}
					}}
				>
					Obter Usuário
				</p>

				<p
					onClick={() => {
						setOpenMoreOptions(false);
						if (tabelaRedux.colunaSelecionada) {
							buscarEmbarquePorId(true);
						} else {
							showToast("Selecione Uma Coluna", "error");
						}
					}}
				>
					Histórico
				</p>
			</BottomSheet>
		</>
	);
}

export default FooterEmbarqueTodos;
